import { useState, useEffect, useRef } from 'react'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import { useDispatch, useSelector } from 'react-redux'
import { getTireAvailabilityStatus } from 'components/common/TireAvailability/actions'
import { createRequestPayloadForInventoryService } from 'components/common/TireAvailability/helpers'
import { getUserData } from 'components/Appointment/selectors'
import { getItemsWithInventory } from 'components/OneColumnSearchResultPage/selectors'
import { setItemsWithInventory, removeItemFromInventoryList } from 'components/OneColumnSearchResultPage/actions'

const useSERPTiresAvailabilityStatus = (params) => {
  const [availability, setAvailability] = useState({})
  const dispatch = useDispatch()
  const {
    countFront,
    countRear,
    brandName,
    frontTireBvId,
    rearTireBvId,
    storeNumber,
    dependencies = [],
    productSkuId,
    isPilotStore
  } = params
  const { ntwBufferDays } = useSelector(getUserData)
  const itemsWithInventory = useSelector(getItemsWithInventory)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isPilotStore && storeNumber) {
      // Skip useEffect logic on first render to avoid extra inventory API call after component render
      if (isFirstRender.current) {
        isFirstRender.current = false

        return
      }

      dispatch(getTireAvailabilityStatus(
        createRequestPayloadForInventoryService(
          countFront,
          countRear,
          brandName,
          ntwBufferDays,
          frontTireBvId,
          rearTireBvId,
          storeNumber),
        productSkuId
      )).then(response => {
        if (!isEmpty(response) && response.data) {
          const { itemDetails } = response.data
          const length = itemDetails?.length
          // This if condition is added to check out of stock status for staggered fitment
          // If any of the front/rear is out of stock then the length will be 1 otherwise it will be 2
          if (frontTireBvId && rearTireBvId && length !== 2) {
            setAvailability({})
          } else if (length) {
            // In case of staggered fitment as well both front and rear will have the same availability status
            setAvailability(itemDetails[0])

            if (isEmpty(itemsWithInventory)) {
              dispatch(setItemsWithInventory(itemDetails))
            } else {
              const filteredProductsWithInventory = itemDetails.filter((item) =>
                itemsWithInventory.some(inventoryItem =>
                  (inventoryItem.partNumber !== item.partNumber)
                    || ((inventoryItem.partNumber === item.partNumber) && (!isEqual(inventoryItem, item)))))

              !isEmpty(filteredProductsWithInventory) && dispatch(setItemsWithInventory(filteredProductsWithInventory))
            }

            const filteredProductsWithInventory = itemsWithInventory.filter((item) =>
              !itemDetails.some(inventoryItem =>
                (inventoryItem.partNumber !== item.partNumber) && !isEqual(inventoryItem, item)))

            !isEmpty(filteredProductsWithInventory) && dispatch(setItemsWithInventory(filteredProductsWithInventory))
          } else {
            setAvailability({})

            if (!isEmpty(itemsWithInventory)) {
              dispatch(removeItemFromInventoryList(frontTireBvId))
            }
          }
        } else {
          setAvailability({})
        }
      }).catch(error => {
        setAvailability({})
        console.log(error)
      })
    }
  }, [...dependencies])

  return [availability, setAvailability]
}

export default useSERPTiresAvailabilityStatus
